<div class="cont">
    <H2 class="head">{{'mediatoru.head'|translate}}</H2>
    <H2 class="head6">{{'mediatoru.text'|translate}}</H2>
    <H4 [innerHTML]="'mediatoru.text1' | translate"></H4>

    <div class="display-row">
        <img src="assets/components/mediatia/1.jpg" alt="Фотография"  height="300">
    </div>

    <H2 class="head7">{{'mediatoru.text2'|translate}}</H2>   
    <H2 class="head6">{{'mediatoru.text3'|translate}}</H2>   
    
    <div class="display-row">
        <img src="assets/components/mediatia/2.png" alt="Фотография"  height="300">
    </div>
    <H4 [innerHTML]="'mediatoru.text4' | translate"></H4>
    <div class="display-row">
        <img src="assets/components/mediatia/3.jpg" alt="Фотография"  height="300">
    </div>
    <H4 [innerHTML]="'mediatoru.text5' | translate"></H4>

    <H2 class="head6">{{'mediatoru.text6'|translate}}</H2>  
    <H2 class="head6">{{'mediatoru.text7'|translate}}</H2>    
    <docs-table [translations]="translations"></docs-table>
    <H2 class="head6">{{'mediatoru.text8'|translate}}</H2>  
    <H2 class="head6">{{'mediatoru.text9'|translate}}</H2>  
    <H2 class="head7">{{'mediatoru.text10'|translate}}</H2>   
    <H2 class="head7">{{'mediatoru.text11'|translate}}</H2>   
    <div class="display-row">
        <img src="assets/components/mediatia/2.png" alt="Фотография"  height="300">
    </div>

    <video width="800" height="500" controls>
        <source src="assets/components/mediatia/video1.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
</div>
